import React from "react";
import ReactDOM from "react-dom";
import "site.scss";
import Root from "./BlogDetailRoot";

ReactDOM.render(<Root />, document.getElementById("app"));

if (DEVELOPMENT) {
    module.hot.accept("BlogDetailRoot", (e) => {
        const Root = require("BlogDetailRoot").default;
        ReactDOM.render(<Root />, document.getElementById("app"));
    });
    __webpack_public_path__ = DEVELOPMENT_SERVER_STATIC_PATH;
}
